// ===== よくある質問 =====
const menuItems = document.querySelectorAll('.p-faq__menuitem');
const faqBoxes = document.querySelectorAll('.p-faq__whole');
menuItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    // アクティブ切り替え
    menuItems.forEach(el => el.classList.remove('u-menuactive'));
    item.classList.add('u-menuactive');

    // ボックス表示切り替え
    faqBoxes.forEach(el => el.classList.remove('js-open'));
    faqBoxes[index].classList.add('js-open');
  });
});
const questions = document.querySelectorAll('.p-faq__question');

questions.forEach(question => {
  question.addEventListener('click', () => {
    const answer = question.nextElementSibling;

    question.classList.toggle('is-active');
    answer.classList.toggle('is-open');
  });
});

// ===== コンセプト =====
const sohumaruConceptButtons = document.querySelectorAll('.sohumaru-concept-tab-btn');
const sohumaruConceptPanels  = document.querySelectorAll('.sohumaru-concept-tab-panel');
const sohumaruConceptTabBody = document.querySelector('.sohumaru-concept-tab-body');

function sohumaruConceptSwitchTab(index) {
  if (!sohumaruConceptTabBody) return;
  // ボタンの active 切り替え
  sohumaruConceptButtons.forEach((btn, i) => {
    btn.classList.toggle('active', i === index);
  });

  // パネルの表示切り替え
  sohumaruConceptPanels.forEach((panel, i) => {
    panel.classList.toggle('active', i === index);
  });

  // ボディのレベルクラス切り替え（枠線・背景色）
  sohumaruConceptTabBody.className =
    `sohumaru-concept-tab-body sohumaru-concept-level-${index}`;
}

// クリックイベント
sohumaruConceptButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    const index = parseInt(btn.dataset.index, 10);
    sohumaruConceptSwitchTab(index);
  });
});

// 初期表示
sohumaruConceptSwitchTab(0);